export const placeTypeOptions = [
  { value: 'HOTEL', label: 'Khách sạn' },
  { value: 'RESORT', label: 'Resort' },
  { value: 'APARTMENT', label: 'Căn hộ' },
  { value: 'VILLA', label: 'Biệt thự' },
];

export const starOptions = [
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  }, {
    value: 4,
    label: 4,
  }, {
    value: 5,
    label: 5,
  },
];

export const landmarksOptions = [
  {
    label: 'Bà Rịa - Vũng Tàu',
    options: [
      {
        value: 'BACK_BEACH',
        label: 'Bãi Sau',
        group: 'VUNG_TAU',
      },
      {
        value: 'FRONT_BEACH',
        label: 'Bãi Trước',
        group: 'VUNG_TAU',
      },
      {
        value: 'PINEAPPLE_BEACH',
        label: 'Bãi Dứa',
        group: 'VUNG_TAU',
      },
      {
        value: 'MULBERRY_BEACH',
        label: 'Bãi Dâu',
        group: 'VUNG_TAU',
      },
      {
        value: 'LONG_CUNG_BEACH',
        label: 'Bãi Biển Long Cung',
        group: 'VUNG_TAU',
      },
      {
        value: 'VUNG_TAU_CITY_BEACH',
        label: 'Trung Tâm Thành Phố Vũng Tàu',
        group: 'VUNG_TAU',
      },
    ],
  },
  {
    label: 'Lâm Đồng',
    options: [
      {
        value: 'XUAN_HUONG_LAKE',
        label: 'Hồ Xuân Hương',
        group: 'DA_LAT',
      },
      {
        value: 'TUYEN_LAM_LAKE',
        group: 'DA_LAT',
        label: 'Hồ Tuyền Lâm',
      },
      {
        value: 'DA_LAT_MARKET',
        group: 'DA_LAT',
        label: 'Chợ Đà Lạt',
      },
    ],
  },
  {
    label: 'Bình Thuận',
    options: [
      {
        value: 'CENTRAL_MUI_NE_BEACH',
        group: 'MUI_NE',
        label: 'Bãi Biển Trung Tâm Mũi Né',
      },
      {
        value: 'RED_SAND_DUNES',
        group: 'MUI_NE',
        label: 'Đồi Cát Đỏ',
      },
      {
        value: 'PHU_HAI_BEACH',
        group: 'MUI_NE',
        label: 'Bãi Biển Phú Hải',
      },
    ],
  },
  {
    label: 'Côn Đảo',
    options: [
      {
        value: 'CON_SON_BEACH',
        group: 'CON_DAO',
        label: 'Bãi Biên Côn Sơn',
      },
      {
        value: 'LO_VOI_BEACH',
        group: 'CON_DAO',
        label: 'Bãi Biển Lò Vôi',
      },
      {
        value: 'SUOI_OT_BEACH',
        group: 'CON_DAO',
        label: 'Bãi Biên Suối Ớt',
      },
      {
        value: 'CON_DAO_HABOUR',
        group: 'CON_DAO',
        label: 'Bến Tàu Côn Đảo',
      },
      {
        value: 'AN_HAI_BEACH',
        group: 'CON_DAO',
        label: 'Bãi Biển An Hải',
      },
      {
        value: 'DAT_DOC_BEACH',
        group: 'CON_DAO',
        label: 'Bãi Biển Đất Dốc',
      },
      {
        value: 'CON_DAO_MARKET',
        group: 'CON_DAO',
        label: 'Chợ Côn Đảo',
      },
    ],
  },
  {
    label: 'Khánh Hòa',
    options: [
      {
        value: 'PONAGAR_TOWER',
        group: 'NHA_TRANG',
        label: 'Tháp Bà Ponagar',
      },
      {
        value: 'DAM_MARKET',
        group: 'NHA_TRANG',
        label: 'Chợ Đầm',
      },
      {
        value: 'NHA_TRANG_BEACH',
        group: 'NHA_TRANG',
        label: 'Bãi Biển Nha Trang',
      },
      {
        value: 'PHAM_VAN_DONG_BEACH',
        group: 'NHA_TRANG',
        label: 'Bãi Biển Phạm Văn Đồng',
      },
      {
        value: 'CAU_DA_MARINA',
        group: 'NHA_TRANG',
        label: 'Cảng Cầu Đá',
      },
      {
        value: 'NHA_TRANG_CITY_CENTER',
        group: 'NHA_TRANG',
        label: 'Trung Tâm Thành Phố Nha Trang',
      },
      {
        value: 'LONG_BEACH',
        group: 'CAM_RANH',
        label: 'Bãi Dài',
      },
      {
        value: 'BINH_BA_ISLAND',
        group: 'CAM_RANH',
        label: 'Đảo Bình Ba',
      },
      {
        value: 'CAM_RANH_BAY',
        group: 'CAM_RANH',
        label: 'Vịnh Cam Ranh',
      },
    ],
  },
  {
    label: 'Bình Định',
    options: [
      {
        value: 'QUY_NHON_BEACH',
        group: 'QUY_NHON',
        label: 'Bãi Biển Quy Nhơn',
      },
      {
        value: 'QUEEN_BEACH',
        group: 'QUY_NHON',
        label: 'Bãi Biển Hoàng Hậu',
      },
      {
        value: 'KY_CO_BEACH',
        group: 'QUY_NHON',
        label: 'Bãi Biển Kỳ Co',
      },
      {
        value: 'QUY_HOA_BEACH',
        group: 'QUY_NHON',
        label: 'Bãi Biển Quy Hòa',
      },
    ],
  },
  {
    label: 'Kiên Giang',
    options: [
      {
        value: 'DUONG_DONG',
        group: 'PHU_QUOC',
        label: 'Dương Đông',
      },
      {
        value: 'AN_THOI',
        group: 'PHU_QUOC',
        label: 'An Thới',
      },
      {
        value: 'CUA_CAN',
        group: 'PHU_QUOC',
        label: 'Cửa Cạn',
      },
      {
        value: 'DUONG_TO',
        group: 'PHU_QUOC',
        label: 'Dương Tơ',
      },
      {
        value: 'THOM_BEACH',
        group: 'PHU_QUOC',
        label: 'Bãi Thơm',
      },
      {
        value: 'HAM_NINH',
        group: 'PHU_QUOC',
        label: 'Hàm Ninh',
      },
      {
        value: 'GANH_DAU',
        group: 'PHU_QUOC',
        label: 'Gành Dầu',
      },
      {
        value: 'ONG_LANG',
        group: 'PHU_QUOC',
        label: 'Ông Lang',
      },
    ],
  },
  {
    label: 'Cần Thơ',
    options: [
      {
        value: 'NINH_KIEU_WHARF',
        group: 'CAN_THO',
        label: 'Bến Ninh Kiều',
      },
      {
        value: 'CAI_RANG_FLOATING_MARKET',
        group: 'CAN_THO',
        label: 'Chợ Nổi Cái Răng',
      },
      {
        value: 'CAN_THO_CITY_CENTER',
        group: 'CAN_THO',
        label: 'Trung Tâm Thành Phố Cần Thơ',
      },
      {
        value: 'KHUONG_RIVER_ISLAND',
        group: 'CAN_THO',
        label: 'Cồn Khương',
      },
      {
        value: 'CAI_KHE_MARKET',
        group: 'CAN_THO',
        label: 'Chợ Cái Khế',
      },
    ],
  },
  {
    label: 'Sa Pa',
    options: [
      {
        value: 'SA_PA_LAKE',
        group: 'SA_PA',
        label: 'Hồ Sa Pa',
      },
      {
        value: 'SA_PA_NIGHT_MARKET',
        group: 'SA_PA',
        label: 'Chợ Đêm Sa Pa',
      },
      {
        value: 'HAM_RONG_MOUNTAIN',
        group: 'SA_PA',
        label: 'Núi Hàm Rồng',
      },
      {
        value: 'MUONG_HOA_VALLEY',
        group: 'SA_PA',
        label: 'Thung Lũng Mường Hoa',
      },
    ],
  },
  {
    label: 'Đà Nẵng',
    options: [
      {
        value: 'HAN_RIVER',
        group: 'DA_NANG',
        label: 'Sông Hàn',
      },
      {
        value: 'MY_KHE_BEACH',
        group: 'DA_NANG',
        label: 'Bãi Biển Mỹ Khê',
      },
      {
        value: 'MARBLE_MOUNTAIN',
        group: 'DA_NANG',
        label: 'Núi Bi',
      },
      {
        value: 'BAC_MY_AN_BEACH',
        group: 'DA_NANG',
        label: 'Bãi Biển Bắc Mỹ An',
      },
      {
        value: 'NON_NUOC_BEACH',
        group: 'DA_NANG',
        label: 'Bãi Biển Non Nước',
      },
      {
        value: 'DA_NANG_BAY',
        group: 'DA_NANG',
        label: 'Vịnh Đà Nẵng',
      },
      {
        value: 'THO_QUANG_BEACH',
        group: 'DA_NANG',
        label: 'Bãi Biển Thọ Quang',
      },
      {
        value: 'SON_TRA_PENINSULA',
        group: 'DA_NANG',
        label: 'Bán Đảo Sơn Trà',
      },
      {
        value: 'DA_NANG_CITY_CENTER',
        group: 'DA_NANG',
        label: 'Trung Tâm Thành Phố Đà Nẵng',
      },
    ],
  },
  {
    label: 'Quảng Nam',
    options: [
      {
        value: 'ANCIENT_TOWN',
        group: 'HOI_AN',
        label: 'Phố Cổ',
      },
      {
        value: 'AN_BANG_BEACH',
        group: 'HOI_AN',
        label: 'Bãi Biển An Bàng',
      },
      {
        value: 'CUA_DAI_BEACH',
        group: 'HOI_AN',
        label: 'Bãi Biển Cửa Đại',
      },
    ],
  },
  {
    label: 'Thừa Thiên Huế',
    options: [
      {
        value: 'IMPERIAL_CITY',
        group: 'HUE',
        label: 'Hoàng Thành',
      },
      {
        value: 'THIEN_MU_PAGODA',
        group: 'HUE',
        label: 'Chùa Thiên Mụ',
      },
      {
        value: 'LANG_CO_BEACH',
        group: 'HUE',
        label: 'Bãi Biển Lăng Cô',
      },
      {
        value: 'THUAN_AN_BEACH',
        group: 'HUE',
        label: 'Bãi Biển Thuận An',
      },
      {
        value: 'HUE_CITY_CENTER',
        group: 'HUE',
        label: 'Trung Tâm Thành Phố Huế',
      },
    ],
  },
];
